import React, { useState, useRef } from "react";
import Sidenav from "../../common/Sidenav";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import DriveFolderUploadIcon from "@mui/icons-material/DriveFolderUpload";
import {
  Grid,
  Button,
  InputLabel,
  Typography,
  TextField,
  Card,
  Divider,
  Snackbar,
  Alert,
  useMediaQuery,
  MenuItem,
  Select,
} from "@mui/material";

import Header from "../../common/Header";
import NavigatedComponent from "../NavigatedComponent";
import { useLocation, useNavigate } from "react-router-dom";
import { DropzoneArea } from "mui-file-dropzone";
import { apiList, invokeApi } from "../../../services/apiServices";
import { config } from "../../../config/config";
import { useCookies } from "react-cookie";
import IconSidenav from "../../common/IconSidenav";
import JoditEditor from "jodit-react";

const AddPeople = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [cookies] = useCookies();
  const [profileImage, setProfileImage] = useState("");
  const [selectedProfileImage, setSelectedProfileImage] = useState("");
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [isUploading, setIsUploading] = useState(false);
  const isMobileScreen = useMediaQuery(
    "(min-width:360px) and (max-width:500px)"
  );
  const editorRef = useRef(null);

  const [people, setPeople] = useState({
    name: "",
    position: "",
    email: "",
    qualifications: "",
    description: "",
    fullProfile1: "",
    fullProfile2: "",
    fullProfile3: "",
    ogUrl: "",
    category: "",
    categoryUrl: "",
    imageUrl: "",
    createdBy: "admin",
  });

  const [showSideNav, setShowSideNav] = useState(false);

  const toggleSideNav = () => {
    setShowSideNav(!showSideNav);
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setPeople((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleProfileImage = (files) => {
    if (files && files.length > 0) {
      const selectedProfileFile = files[0];
      setProfileImage(selectedProfileFile);
      setSelectedProfileImage(selectedProfileFile.name);
    } else {
      setProfileImage(null);
      setSelectedProfileImage("");
    }
  };

  const showSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setOpenSnackbar(true);
  };

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  const handleAddProfileImage = async () => {
    if (!profileImage) {
      showSnackbar("Please select a profile image", "error");
      return "";
    }

    setIsUploading(true);
    const formData = new FormData();
    formData.append("profile", profileImage);

    try {
      const response = await fetch("https://api.reef.org.in/addProfileImage", {
        method: "POST",
        body: formData,
      });

      // Check if response is ok
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const responseData = await response.json();
      console.log("Profile image upload response:", responseData);

      // More flexible response handling
      if (responseData.responseCode === 200 || responseData.success) {
        const uploadedImageUrl = responseData.imageUrl || responseData.url || responseData.data?.imageUrl;
        showSnackbar("Profile image uploaded successfully", "success");
        return uploadedImageUrl || "";
      } else {
        const errorMessage = responseData.responseMessage || responseData.message || "Failed to upload profile image";
        showSnackbar(errorMessage, "error");
        return "";
      }
    } catch (error) {
      console.error("Profile image upload error:", error);
      showSnackbar("Failed to upload image. Please try again.", "error");
      return "";
    } finally {
      setIsUploading(false);
    }
  };

  const handleAddPeople = async (imageUrl) => {
    const params = {
      ...people,
      imageUrl,
    };

    try {
      const response = await invokeApi(
        config.getMyCollege + apiList.addPeople,
        params,
        cookies
      );

      console.log("Add people response:", response);

      if (response?.status >= 200 && response?.status < 300) {
        if (response.data.responseCode === "200" || response.data.success) {
          showSnackbar("Person Added successfully", "success");
          setTimeout(() => {
            navigate("/people-manager/people-list");
          }, 1000);
        } else if (response.data.responseCode === "400") {
          showSnackbar(response.data.message, "error");
        }
      } else {
        showSnackbar("Failed to add person", "error");
      }
    } catch (error) {
      console.error("Error during adding person:", error);
      showSnackbar("Something went wrong. Please try again later!!", "error");
    }
  };

  const handlePeopleSubmit = async (event) => {
    event.preventDefault();

    // Validation
    if (!people.name.trim()) {
      showSnackbar("Please enter name", "error");
      return;
    }

    if (!people.position.trim()) {
      showSnackbar("Please enter position", "error");
      return;
    }

    if (!people.email.trim()) {
      showSnackbar("Please enter email", "error");
      return;
    }

    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(people.email)) {
      showSnackbar("Please enter a valid email address", "error");
      return;
    }

    if (!profileImage) {
      showSnackbar("Please select a profile image", "error");
      return;
    }

    if (isUploading) {
      showSnackbar("Upload in progress, please wait...", "info");
      return;
    }

    try {
      const imageUrl = await handleAddProfileImage();
      if (imageUrl) {
        await handleAddPeople(imageUrl);
      }
    } catch (error) {
      console.error("Error while adding person details:", error);
      showSnackbar("Something went wrong. Please try again later.", "error");
    }
  };

  return (
    <>
      <Grid sx={{ display: "flex" }}>
        {isMobileScreen ? (
          <IconSidenav />
        ) : showSideNav ? (
          <IconSidenav />
        ) : (
          <Sidenav />
        )}
        <Grid component="main" sx={{ width: "100%", px: 1 }}>
          <Header toggleSideNav={toggleSideNav} />
          <Grid sx={{ py: 1 }}>
            <NavigatedComponent pathname={location.pathname} />
            <Grid sx={{ width: "100%", px: isMobileScreen ? 1 : 5 }}>
              <Card elevation={1} sx={{ my: 5 }}>
                <Grid sx={{ py: isMobileScreen ? 2 : 2 }}>
                  <Typography
                    sx={{
                      mb: 2,
                      mx: isMobileScreen ? 2 : 8,
                      textAlign: "left",
                      fontSize: isMobileScreen ? 14 : 18,
                      fontWeight: 600,
                      textTransform: "uppercase",
                    }}
                  >
                    Add New Person
                  </Typography>
                  <Divider sx={{ mb: 3 }} />

                  <form onSubmit={handlePeopleSubmit}>
                    <Grid
                      container
                      md={12}
                      xs={12}
                      sx={{
                        width: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-around",
                        my: 2,
                      }}
                    >
                      {/* Basic Information */}
                      <Grid item md={11} xs={11} sx={{ my: 2 }}>
                        <InputLabel
                          sx={{
                            fontWeight: "bold",
                            my: 1,
                            fontSize: isMobileScreen ? 12 : 15,
                          }}
                        >
                          Name *
                        </InputLabel>
                        <TextField
                          placeholder="Enter Name"
                          fullWidth
                          name="name"
                          value={people.name}
                          onChange={handleInputChange}
                          inputProps={{
                            style: {
                              height: isMobileScreen ? "3px" : "8px",
                              fontSize: isMobileScreen ? 12 : 14,
                            },
                          }}
                          required
                        />
                      </Grid>

                      <Grid item md={11} xs={11} sx={{ my: 2 }}>
                        <InputLabel
                          sx={{
                            fontWeight: "bold",
                            my: 1,
                            fontSize: isMobileScreen ? 12 : 15,
                          }}
                        >
                          Position *
                        </InputLabel>
                        <TextField
                          placeholder="Enter Position"
                          fullWidth
                          name="position"
                          value={people.position}
                          onChange={handleInputChange}
                          inputProps={{
                            style: {
                              height: isMobileScreen ? "3px" : "8px",
                              fontSize: isMobileScreen ? 12 : 14,
                            },
                          }}
                          required
                        />
                      </Grid>

                      <Grid item md={11} xs={11} sx={{ my: 2 }}>
                        <InputLabel
                          sx={{
                            fontWeight: "bold",
                            my: 1,
                            fontSize: isMobileScreen ? 12 : 15,
                          }}
                        >
                          Email *
                        </InputLabel>
                        <TextField
                          placeholder="Enter Email"
                          fullWidth
                          name="email"
                          type="email"
                          value={people.email}
                          onChange={handleInputChange}
                          inputProps={{
                            style: {
                              height: isMobileScreen ? "3px" : "8px",
                              fontSize: isMobileScreen ? 12 : 14,
                            },
                          }}
                          required
                        />
                      </Grid>

                      <Grid item md={11} xs={11} sx={{ my: 2 }}>
                        <InputLabel
                          sx={{
                            fontWeight: "bold",
                            my: 1,
                            fontSize: isMobileScreen ? 12 : 15,
                          }}
                        >
                          Qualifications
                        </InputLabel>
                        <TextField
                          placeholder="Enter Qualifications"
                          fullWidth
                          name="qualifications"
                          value={people.qualifications}
                          onChange={handleInputChange}
                          inputProps={{
                            style: {
                              height: isMobileScreen ? "3px" : "8px",
                              fontSize: isMobileScreen ? 12 : 14,
                            },
                          }}
                        />
                      </Grid>

                      <Grid item md={11} xs={11} sx={{ my: 2 }}>
                        <InputLabel
                          sx={{
                            fontWeight: "bold",
                            my: 1,
                            fontSize: isMobileScreen ? 12 : 15,
                          }}
                        >
                          Description
                        </InputLabel>
                        <TextField
                          placeholder="Enter Description"
                          fullWidth
                          multiline
                          rows={3}
                          name="description"
                          value={people.description}
                          onChange={handleInputChange}
                          inputProps={{
                            style: {
                              fontSize: isMobileScreen ? 12 : 14,
                            },
                          }}
                        />
                      </Grid>

                      {/* Full Profile Sections */}
                      <Grid item md={11} xs={11} sx={{ my: 2 }}>
                        <InputLabel
                          sx={{
                            fontWeight: "bold",
                            my: 1,
                            fontSize: isMobileScreen ? 12 : 15,
                          }}
                        >
                          Full Profile 1
                        </InputLabel>
                        <TextField
                          placeholder="Enter full profile details"
                          fullWidth
                          multiline
                          rows={3}
                          name="fullProfile1"
                          value={people.fullProfile1}
                          onChange={handleInputChange}
                          inputProps={{
                            style: {
                              fontSize: isMobileScreen ? 12 : 14,
                            },
                          }}
                        />
                      </Grid>

                      <Grid item md={11} xs={11} sx={{ my: 2 }}>
                        <InputLabel
                          sx={{
                            fontWeight: "bold",
                            my: 1,
                            fontSize: isMobileScreen ? 12 : 15,
                          }}
                        >
                          Full Profile 2
                        </InputLabel>
                        <TextField
                          placeholder="Enter additional profile details"
                          fullWidth
                          multiline
                          rows={3}
                          name="fullProfile2"
                          value={people.fullProfile2}
                          onChange={handleInputChange}
                          inputProps={{
                            style: {
                              fontSize: isMobileScreen ? 12 : 14,
                            },
                          }}
                        />
                      </Grid>

                      <Grid item md={11} xs={11} sx={{ my: 2 }}>
                        <InputLabel
                          sx={{
                            fontWeight: "bold",
                            my: 1,
                            fontSize: isMobileScreen ? 12 : 15,
                          }}
                        >
                          Full Profile 3
                        </InputLabel>
                        <TextField
                          placeholder="Enter more profile details"
                          fullWidth
                          multiline
                          rows={3}
                          name="fullProfile3"
                          value={people.fullProfile3}
                          onChange={handleInputChange}
                          inputProps={{
                            style: {
                              fontSize: isMobileScreen ? 12 : 14,
                            },
                          }}
                        />
                      </Grid>

                      {/* URL and Category Information */}
                      <Grid item md={11} xs={11} sx={{ my: 2 }}>
                        <InputLabel
                          sx={{
                            fontWeight: "bold",
                            my: 1,
                            fontSize: isMobileScreen ? 12 : 15,
                          }}
                        >
                          OG URL
                        </InputLabel>
                        <TextField
                          placeholder="Enter OG URL"
                          fullWidth
                          name="ogUrl"
                          value={people.ogUrl}
                          onChange={handleInputChange}
                          inputProps={{
                            style: {
                              height: isMobileScreen ? "3px" : "8px",
                              fontSize: isMobileScreen ? 12 : 14,
                            },
                          }}
                        />
                      </Grid>

                      <Grid item md={11} xs={11} sx={{ my: 2 }}>
                        <InputLabel
                          sx={{
                            fontWeight: "bold",
                            my: 1,
                            fontSize: isMobileScreen ? 12 : 15,
                          }}
                        >
                          Category
                        </InputLabel>
                        <TextField
                          placeholder="Enter Category"
                          fullWidth
                          name="category"
                          value={people.category}
                          onChange={handleInputChange}
                          inputProps={{
                            style: {
                              height: isMobileScreen ? "3px" : "8px",
                              fontSize: isMobileScreen ? 12 : 14,
                            },
                          }}
                        />
                      </Grid>

                      <Grid item md={11} xs={11} sx={{ my: 2 }}>
                        <InputLabel
                          sx={{
                            fontWeight: "bold",
                            my: 1,
                            fontSize: isMobileScreen ? 12 : 15,
                          }}
                        >
                          Category URL
                        </InputLabel>
                        <TextField
                          placeholder="Enter Category URL"
                          fullWidth
                          name="categoryUrl"
                          value={people.categoryUrl}
                          onChange={handleInputChange}
                          inputProps={{
                            style: {
                              height: isMobileScreen ? "3px" : "8px",
                              fontSize: isMobileScreen ? 12 : 14,
                            },
                          }}
                        />
                      </Grid>

                      {/* Profile Image Upload */}
                      <Grid
                        container
                        md={12}
                        sx={{
                          width: "100%",
                          justifyContent: "space-around",
                          my: 5,
                        }}
                      >
                        <Grid item md={5} xs={11}>
                          <InputLabel
                            sx={{
                              fontWeight: "bold",
                              my: 1,
                              fontSize: isMobileScreen ? 12 : 15,
                            }}
                          >
                            Profile Image *
                          </InputLabel>
                          <Grid
                            sx={{
                              my: 4,
                              ".MuiBox-root ": {
                                bgcolor: "#f0f8ff",
                                borderColor: "#1d1a57",
                                minHeight: 0,
                                my: 1,
                                alignItems: "center",
                                justifyContent: "center",
                              },
                            }}
                          >
                            <DropzoneArea
                              filesLimit={1}
                              onChange={handleProfileImage}
                              acceptedFiles={[
                                "image/jpeg",
                                "image/png",
                                "image/jpg",
                              ]}
                              maxFileSize={5000000}
                              showPreviews={true}
                              showAlerts={false}
                              showPreviewsInDropzone={false}
                              showFileNames={false}
                              Icon={(props) => (
                                <CloudUploadIcon
                                  style={{
                                    color: "#1d1a57",
                                    width: 35,
                                    height: 35,
                                  }}
                                  {...props}
                                />
                              )}
                              dropzoneText={
                                <Typography
                                  sx={{
                                    color: "#1d1a57",
                                    fontWeight: 600,
                                    fontSize: 16,
                                  }}
                                >
                                  Upload / Drag Profile Image
                                </Typography>
                              }
                              previewText="Selected Profile Image:"
                            />
                          </Grid>
                          {selectedProfileImage && (
                            <Typography
                              sx={{
                                fontSize: 12,
                                color: "green",
                                mt: 1,
                              }}
                            >
                              Selected: {selectedProfileImage}
                            </Typography>
                          )}
                        </Grid>
                      </Grid>
                    </Grid>

                    <Divider sx={{ mb: 1 }} />
                    <Grid
                      container
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Button
                        type="submit"
                        disabled={isUploading}
                        sx={{
                          my: 2,
                          px: 2,
                          fontSize: 12,
                          background: isUploading ? "#ccc" : "#1d1a57",
                          color: "#FFF",
                          fontWeight: 600,
                          "&:hover": {
                            background: isUploading ? "#ccc" : "#1d1a57",
                            color: "#FFF",
                          },
                        }}
                      >
                        <DriveFolderUploadIcon />
                        &nbsp; {isUploading ? "Uploading..." : "Add Person"}
                      </Button>
                    </Grid>
                  </form>
                </Grid>
              </Card>

              {/* Snackbar */}
              <Snackbar
                open={openSnackbar}
                autoHideDuration={3000}
                onClose={handleCloseSnackbar}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
              >
                <Alert
                  onClose={handleCloseSnackbar}
                  severity={snackbarSeverity}
                  sx={{ width: '100%' }}
                >
                  {snackbarMessage}
                </Alert>
              </Snackbar>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default AddPeople;